<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="device">Reward Type </label>
                  <b-form-select id="device" :plain="true" :options="priceTypeList" v-model="sType" text-field="label" value-field="key">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search()"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-globe'></i> Reward List</h3>
              <b-button variant="primary" class="float-right" @click="showAddModal" v-if="checkAccessPrivilege('ScratchCard.Rewards.Add')">Add Reward</b-button>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
                <template v-slot:row-details="data">
                  <p v-html="data.item.Description"></p>
                </template>
                <template v-slot:cell(ImageUrl)="data">
                  <img :src="data.item.ImageUrl" width="120px"/>
                </template>
                <template v-slot:cell(Amount)="data">
                  {{ data.item.Amount }} {{ (data.item.Type === 1) ? 'Credits' : (data.item.Type === 2) ? 'Points' : '' }}
                </template>
                <template v-slot:cell(Status)="data">
                  <b-badge variant="success" v-if="data.item.Status === 1">Enabled</b-badge>
                  <b-badge variant="danger" v-else-if="data.item.Status === 0">Disabled</b-badge>
                </template>
                <template v-slot:cell(Action)="data" v-if="checkAccessPrivilege('ScratchCard.Rewards.Update')">
                  <b-button class="btn-sm" variant="warning" @click="showUpdateModal(data.item)">Edit</b-button>
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <add-modal :show-modal="addModal" :price-type-list="priceTypeList" @closeModal="closeAddModal"/>
    <update-modal :show-modal="updateModal" :update-data="updateData" :price-type-list="priceTypeList" @closeModal="closeUpdateModal"/>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import AddModal from './AddReward'
import UpdateModal from './UpdateReward'

export default {
  name: 'scratchcard-reward-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Id', label: 'Id'},
        {key: 'Name', label: 'Name'},
        {key: 'ImageUrl', label: 'Image Url'},
        {key: 'Amount', label: 'Reward', sortable: true},
        {key: 'Action', label: 'Action'}
      ],
      priceTypeList: [
        {key: '1', label: 'Credits'},
        {key: '2', label: 'Points'}
      ],
      sType: null,
      perPage: 10,
      currentPage: 1,
      updateModal: false,
      updateData: {},
      addModal: false
    }
  },
  components: {
    AddModal,
    UpdateModal
  },
  methods: {
    getRowCount (item) {
      return item.length
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `type=${this.sType || ''}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/scratchcard/reward/all?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.items = data
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    showDetail (item) {
      if (item._showDetails) {
        item._showDetails = false
      } else {
        this.$set(item, '_showDetails', true)
      }
    },
    showUpdateModal (item) {
      this.updateData = item
      this.updateModal = true
    },
    closeUpdateModal () {
      this.updateData = {}
      this.updateModal = false
      this.search()
    },
    showAddModal () {
      this.addModal = true
    },
    closeAddModal () {
      this.addModal = false
      this.search()
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  created () {
    this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/scratchcard/rewards/RewardsTable.vue